module.exports = __webpack_public_path__ + "img/nodeType4.990556ed.svg";